<template lang="pug">
#appShareContainer
  .pwdAppPage(v-if="isNeedPwd === 0")
    el-input(v-model='code' placeholder='请输入提取密码')
    el-button(type='primary' @click='extractBtn') 提取文件
  .linkFailureAppPage(v-if="isTimeOu")
    img(src='../../../assets/public/noDatas.png' alt='等你等的链接都失效了')
    p 来晚了，该分享已失效
  .shareFilesAppPage(v-if="isNeedPwd !== 0 && !isTimeOu")
    .shareInfo
      img.userAvator(v-if="allMessage.img" :src="allMessage.img")
      .avatortox(v-else) {{allMessage.tox}}
      .info
        .shareN 分享人：{{allMessage.operUserName}}
        .shareN 有效期限：{{validityPeriod}}
      .right
        img(src='../../../assets/public/card.png' alt='等你等的链接都失效了' v-if="isShowList" @click="changeType")
        img(src='../../../assets/public/list.png' alt='等你等的链接都失效了' v-else @click="changeType")
    .nav
      el-breadcrumb(ref='breadDiv' separator='/')
        el-breadcrumb-item(v-for='(item, index) in navList' :key='index' style='cursor: pointer')
          span.ellipsis(@click='index !== (navList.length - 1) && clickBread(item,index)')
            | {{ item.name}}
    .fileBox
      ul(v-if="isShowList")
        li(v-for="(item,index) in shareArr" :key="index" class="fileList" @click="clickFolderOrFile(item,'h5')")
          img(:src="nameIcon(item)")
          .fileContent
            p {{item.folderName}}
            p {{item.operDate}}
      .boxlist(v-else)
        .fileCard(v-for="(item,index) in shareArr" :key="index" @click="clickFolderOrFile(item,'h5')")
          img(:src="nameIcon(item)")
          p.name {{item.folderName}}
          p.date {{item.operDate}}
</template>

<script>
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import shareCommon from "./../shareCommon";
export default {
  mixins: [shareCommon],
  data() {
    return {
      isNeedPwd: '', // 是否需要提取码
      isTimeOu: false, // 是否失效
      backupsArr: [],
      navList: [], // 文件夹层级
      shareArr: [], // 展示列表
      isDownload: '', // 是否有下载权限
      shareToken: '', // 分享人
      argument: {
        folderId: "",
        prjId: "",
        isRead: 1,
        priviAll: "1",
        versionId: "",
        versionName: "",
        isNew: "",
        userId: ""
      },
      downrul: require("@/CommonDP/assets/public/down.png"),
      code: '',
      loadBoolean: false,
      isShowList: true
    };
  },
  computed: {
    validityPeriod() {
      return this.allMessage.endDate === "2099-12-31 23:59:59" ? "永久有效" : this.allMessage.endDate;
    }
  },
  methods: {
    changeType() {
      this.isShowList = !this.isShowList;
    },
    nameIcon(row) {
      return tableRowIcon(row);
    }
  }
};
</script>

<style lang="scss"  scoped>
#appShareContainer {
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/public/shareBgH5.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #EEF2F6;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .pwdAppPage{
    width:320px;
    height: 320px;
    box-sizing: border-box;
    background-color: rgba(50,50,50,0.62);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-160px) translateY(-160px);
    border-radius: 160px;
    padding-top: 110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-input{
      margin-bottom: 15px;
      padding: 0px 26px;
      /deep/ .el-input__inner{
        background: #F4F7FF;
        border-radius: 10px !important;
        border: none;
      }
    }
    .el-button{
      width: 86%;
      height: 44px;
      background: var(--theme-color);
      box-shadow: 0px 0px 20px rgba(51, 114, 255, 0.54);
      border-radius: 10px;
      /deep/ span{
        font-weight: 500;
        font-size: 18px;
      }
    }
  }
  .linkFailureAppPage{
    img{
      width:240px;
      height:213px;
    }
    p{
      font-weight: 500;
      font-size: 18px;
      color: #FFF;
      text-align: center;
    }
  }
  .shareFilesAppPage{
    margin-top: 44px;
    width:100%;
    height: calc(100% - 44px);
    position: relative;
    .shareInfo{
      width: 100%;
      height: 44px;
      display: flex;
      flex-direction: row;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.9);
      padding: 0 16px;
      .userAvator{
        width: 30px;
        height: 30px;
        border-radius: 15px;
        margin-right: 10px;
      }
      .avatortox{
        width: 30px;
        height: 30px;
        border-radius: 15px;
        line-height: 30px;
        font-size: 16px;
        font-weight: 700;
        color: #127DFB;
        margin-right: 10px;
        text-align: center;
        background-color: #EBF3FB;
      }
      .right{
        margin-left: auto;
        display: flex;
        flex-direction: row;
        img{
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }
      }
    }
    .title,.nav{
      width: 100%;
      height: 44px;
      background-color: rgba(255, 255, 255, 0.9);
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 16px;
      overflow-x: auto;
      /deep/.el-breadcrumb{
        margin-left: 10px;
        .el-breadcrumb__item{
          display: flex;
          flex-direction: row;
        }
        .el-breadcrumb__inner{
          display: inline;
          color: #fff;
        }
      }
      .right{
        margin-left: auto;
        display: flex;
        flex-direction: row;
        img{
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }
      }
      .ellipsis{
        color: var(--info-color);
        font-weight: 600;
        font-size: 14px;
        width: 100%;
        display: block;
        text-align: center;
      }
    }
    .fileBox{
      width: 100%;
      height: calc(100% - 88px);
      overflow-y: auto;
      background-color: rgba(255, 255, 255, 0.9);;
      padding: 0 16px;
      .fileList{
        width: 100%;
        height: 70px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid #e5e8f1;
        .img{
          width: 33px;
          height: 33px;
          margin-right: 5px;
        }
        .fileContent{
          width: calc(100% - 40px);
          padding-left: 5px;
          display: flex;
          flex-direction: column;
          p{
            width: 100%;
            line-height: 20px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
      .boxlist{
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding-top: 5px;
        .fileCard{
          width: 105px;
          height: 120px;
          margin: 0 5px 5px 0;
          box-sizing: border-box;
          border: 1px solid rgba(51,51,51,.1);
          border-radius: 5px;
          background: rgba(235,243,251,.6);
          display: flex;
          flex-direction: column;
          align-items: center;
          img{
            width: 49px;
            height: 49px;
            margin-top: 9px;
          }
          .name{
            font-weight: 400;
            font-size: 14px;
            text-align: center;
            color: var(--key-color);
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 100%;
            padding: 0 2px;
          }
          .date{
            text-align: center;
            font-weight: 400;
            font-size: 11px;
            color: var(--info-color);
            margin-top: 2px;
          }
        }
      }
    }

  }
}
</style>
